import React from 'react';
import { Box, Typography, Card, CardHeader, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
    marginBottom: 0,
    boxShadow: 'none',
    borderTop: 'none',
    borderBottom: 'none',
    borderRadius: 0,
}));

const PositionReview = ({ reviewPolicy }) => {
    const renderValue = (value) => {
        return value || '-';
    };

    return (
        <StyledCard>
            <CardHeader
                title={
                    <Typography variant="h5" component="h2">
                        Review Policy Details
                    </Typography>
                }
            />
            <CardContent>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                        Review Policy
                    </Typography>
                    <Typography variant="body1" fontWeight={500}>
                        {renderValue(reviewPolicy?.name)}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 4 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                            Approver
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                            {renderValue(reviewPolicy?.approver?.name)}
                        </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
                            Reviewer
                        </Typography>
                        <Typography variant="body1" fontWeight={500}>
                            {renderValue(reviewPolicy?.reviewer?.name)}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </StyledCard>
    );
};

export default PositionReview;
